import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "menu";
var classes = {
    POPUP: 'tyl-menu__popup',
    MENU: 'mdc-menu'
};
var selectors = {
    TOGGLE: "." + COMPONENT_NAME_PREFIX + "menu__toggle, [" + elementName + "-toggle], button, [type=button]",
    MENU_LIST: 'tcw-list'
};
var attributes = {
    OPEN: 'open',
    PLACEMENT: 'placement',
    SELECTED_INDEX: 'selected-index',
    SELECTED_VALUE: 'selected-value',
    DENSE: 'dense',
    ICON_CLASS: 'icon-class',
    PERSIST_SELECTION: 'persist-selection',
    MODE: 'mode',
    SYNC_POPUP_WIDTH: 'sync-popup-width',
    HIGHLIGHT_FIRST: 'highlight-first',
    POPUP_CLASSES: 'popup-classes',
    OPTION_LIMIT: 'option-limit',
    OBSERVE_SCROLL: 'observe-scroll',
    OBSERVE_SCROLL_THRESHOLD: 'observe-scroll-threshold'
};
var events = {
    SELECT: elementName + "-select",
    OPEN: elementName + "-open",
    CLOSE: elementName + "-close",
    ACTIVE_CHANGE: elementName + "-active-change"
};
var numbers = {
    CHILD_MOUSE_LEAVE_TIMEOUT: 300,
    POPUP_MOUSE_LEAVE_TIMEOUT: 500
};
export var MENU_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    events: events,
    numbers: numbers
};
